module.exports = __webpack_public_path__ + "img/preview-empty-query.e02d0536.webp";